<template>
  <div v-if="breadcrumbItems && breadcrumbItems.length > 0" class="bread-container">
    <v-breadcrumbs style="padding: 0" class="bread-info font-weight-black" :items="breadcrumbItems">
      <template #item="{ item }">
        <a v-if="item.href" @click="handleReplace(item.href)">{{ item.text }}</a>
        <span v-else>{{ item.text }}</span>
      </template>
    </v-breadcrumbs>
    <v-btn
      v-if="breadcrumbItems.length > 1"
      class="back-btn"
      color="primary"
      text
      small
      @click="goBack"
    >
      <v-icon>mdi-arrow-left</v-icon>
      <span>返回</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  computed: {
    breadcrumbItems() {
      return getBreadcrumbItems(this.$route)
    }
  },

  methods: {
    handleReplace(href) {
      this.$router.replace(href)
    },
    goBack() {
      this.$router.replace(this.breadcrumbItems[this.breadcrumbItems.length - 2].href)
    }
  }
}

const TabConfig = {
  ['my-course']: '我的课程',
  ['my-prepare']: '我的备课',
  ['trial-class']: 'DEMO课'
}
function getBreadcrumbItems(routeItem) {
  const { name, meta, params, query } = routeItem
  if (!['group', 'info'].includes(name)) {
    return []
  }
  const { tab } = meta
  const items = [{ text: TabConfig[tab], href: `/${tab}` }]
  switch (name) {
    case 'group':
      items.push({ text: `课程：${query.courseName}` })
      break
    case 'info': {
      const groupId = tab === 'trial-class' ? params.courseId : query.group
      items.push({
        text: `课程：${query.courseName}`,
        href: `/${tab}/group/${groupId}?courseName=${query.courseName}`
      })
      items.push({ text: `课节：${query.sectionName}` })
      break
    }
  }
  return items
}
</script>

<style>
.bread-container {
  height: 30px;
  line-height: 30px;
  position: fixed;
  top: 64px;
  left: 0;
  z-index: 10;
  padding-left: 20px;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.back-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 5px;
  padding: 0 5px !important;

  color: #666;
  line-height: 26px;
  height: 26px;
}

.back-btn .mdi-arrow-left {
  font-size: 18px !important;
}
.back-btn span {
  margin-left: 0;
  font-size: 14px;
}

.bread-info li,
.bread-info a {
  font-size: 14px !important;
  color: #999 !important;
}
.bread-info span {
  font-size: 14px !important;
  color: #666 !important;
}

.bread-info a:hover {
  color: #1976d2 !important;
  text-decoration: none;
  background-color: none;
}

.bread-info .v-breadcrumbs__item--disabled {
  color: #999 !important;
}
</style>
